<template>
  <div class="px-15" v-if="campaign">
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-primary btn-round dropdown-toggle"
        data-toggle="dropdown"
        aria-expanded="false"
        style="text-transform: uppercase"
      >
        {{ campaign.status }}
      </button>
      <div class="dropdown-menu" role="menu">
        <a
          v-if="campaign.status == 'draft'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('ongoing')"
        >
          <i class="icon md-long-arrow-up" aria-hidden="true"></i>Start
        </a>

        <a
          v-if="campaign.status == 'draft'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('archived')"
        >
          <i class="icon md-archive" aria-hidden="true"></i>Archive
        </a>

        <a
          v-if="campaign.status == 'end'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('ongoing')"
        >
          <i class="icon md-long-arrow-down" aria-hidden="true"> </i>
          Restart
        </a>

        <a
          v-if="campaign.status == 'ongoing'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="confirmStop"
        >
          <i class="icon md-border-color" aria-hidden="true"></i>Stop
        </a>

        <a
          v-if="campaign.status == 'archived'"
          class="dropdown-item"
          href="javascript:void(0)"
          role="menuitem"
          @click="update('draft')"
        >
          <i class="icon md-long-arrow-up" aria-hidden="true"></i>Unarchive
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { wsgtdriveService } from "@/api/client";

export default {
  props: ["campaign"],

  methods: {
    async confirmStop() {
      const r = confirm("คุณต้องการ Stop campaign นี้ใช่หรือไม่?");
      r ? this.update("end") : null;
    },

    async update(status) {
      try {
        const { id } = this.campaign;
        const form = {
          status: status,
        };

        await wsgtdriveService.updateCampaignInfo(id, form);
        this.$emit("updated");
        this.$notify("Status updated");
      } catch (error) {
        error.response
          ? this.$dialogs.alert(error.response.data)
          : this.$dialogs.alert(error);
      }
    },
  },
};
</script>

<style></style>
